
import { createApiClient } from 'Network/ApiClient';

export const ActivityAllowedAxiosInstance = createApiClient('Activity/');


